import { Banner } from '../banner/Banner';

import bannerImg from './denmark_beach_bikes.png';

const bannerContent = {
    header: 'Oppdag verden fra sykkelsetet',
    text: 'Vi gir deg tipsene til uforglemmelige sykkelferier i Norge og utlandet.',
    callToAction: 'Bli inspirert',
    link: 'https://www.finn.no/reise/artikler/aktivitet/sykkelferie',
    img: {
        src: bannerImg.src,
        alt: '4 sykler parkert på en hvit sandstrand med sykkelhjelmer over styret i fint vær',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
